import { Videos } from '../_app/cuchillo/components/Videos';
import { Acordions } from '../_app/cuchillo/components/Acordions';
import { isMobile } from '../_app/cuchillo/core/Basics';
import { FormValidator } from '../_app/cuchillo/forms/FormValidator';
import { ControllerPage } from '../_app/cuchillo/pages/ControllerPage';
import Page from '../_app/cuchillo/pages/Page';
import { Scroll } from '../_app/cuchillo/scroll/Scroll';
import Preloader from '../layout/Preloader';
import Wrap from '../layout/Wrap';
import Keyboard from '../_app/cuchillo/core/Keyboard';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class Default extends Page {
  _footerForm;
  _newsletterForm;

  constructor() {
    super();

    Videos.init();
    Acordions.init();

    // this._footerForm = new FormValidator(GetBy.selector('#Footer .form')[0]);
    // this._newsletterForm = new FormValidator(GetBy.selector('#Newsletter .form')[0]);
  }

  //SHOW
  beforeShow() {
    Scroll.init(Scroll.AXIS_Y, { domResize: this.container, smooth: !isMobile, multiplicator: 1 });
    Keyboard.mountPage(this.id);
  }

  show__effect(__call) {
    if (this.isFirstTime) {
      Wrap.show(() => {
        Preloader.hide(() => { this.afterShow() });
      });
    } else {
      Wrap.show(() => { this.afterShow() });
    }
  }

  afterShow() {
    super.afterShow();
    Scroll.start();
    Scroll.show();
  }

  //HIDE
  beforeHide() {
    super.beforeHide();
    Keyboard.unmountPage(this.id);
  }

  hide__effect() {
    Scroll.hide();
    Wrap.hide(() => { this.afterHide(); });
  }

  afterHide() {
    Scroll.dispose();
    super.afterHide();
  }

  //RESIZE
  resize() {
    super.resize();
    Acordions.resize();
  }

  //LOOP
  loop() {
    if (this._isActive) {
      super.loop();
    }
  }

  dispose() {
    super.dispose();
    // this._footerForm.dispose();
    // this._newsletterForm.dispose();
  }
}

ControllerPage._addPage('default', Default);
